import { type Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Inicio',
        loadComponent: () => import('./feature/home/home').then((m) => m.Home),
      },
      {
        path: 'admin',
        loadChildren: () => import('./feature/admin/admin.routing').then((m) => m.AdminRoutes),
      },
      {
        path: 'facilities',
        loadChildren: () => import('./feature/facilities/facilities.routing').then((m) => m.FacilitiesRoutes),
      },
      {
        path: 'masters',
        loadChildren: () => import('./feature/masters/masters.routing').then((m) => m.MastersRoutes),
      },
      {
        path: 'parameters',
        loadChildren: () => import('./feature/parameters/parameters.routing').then((m) => m.ParametersRoutes),
      },
      {
        path: 'utils',
        title: 'Utilidades',
        loadChildren: () => import('./feature/utils/utils.routing').then((m) => m.UtilsRoutes),
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
